import React, { useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import axios from "axios";
import "../AddAdvertisement/AddAdvertisement.css";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AddAdvertisement() {
  const [images, setImages] = useState([]);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
const [selectedCategoryId, setSelectedCategoryId] = useState("");
  // ================= Upload Images =================
  const handleImagesUpload = (e) => {
    const files = Array.from(e.target.files);

    if (files.length + images.length > 10) {
      toast.warning("الحد الأقصى للصور هو 10 ");
      return;
    }

    const newImages = files.map((file) => ({
      file,
      url: URL.createObjectURL(file),
    }));

    setImages((prev) => [...prev, ...newImages]);
  };

  // ================= Delete Image =================
  const deleteImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };


// const handleSubmit = async (e) => {
//   e.preventDefault();

//   const form = e.target;
//   let newErrors = {};

//   // ========= Validation =========
//   if (!form.name.value.trim()) {
//     newErrors.name = "الاسم مطلوب";
//   }

//   if (!form.price.value || Number(form.price.value) <= 0) {
//     newErrors.price = "السعر مطلوب";
//   }

//   if (!form.description.value.trim()) {
//     newErrors.description = "الوصف مطلوب";
//   }

//   if (images.length === 0) {
//     newErrors.images = "مطلوب صورة واحدة على الأقل";
//   }

//   if (Object.keys(newErrors).length > 0) {
//     setErrors(newErrors);
//     return;
//   }

//   setErrors({});
//   setFormSubmitting(true);

//   try {
//     const formData = new FormData();

//     formData.append("name", form.name.value);
//     formData.append("price", form.price.value);
//     formData.append("discount", form.discount.value || 0);
//     formData.append("description", form.description.value);

//     images.forEach((img) => {
//       formData.append("images[]", img.file);
//     });

//     const token = localStorage.getItem("token");

//     await axios.post(
//       BaseUrl + BuyerServicesUrl.AddAdvertisement,
//       formData,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       }
//     );

//     toast.success("تم نشر الإعلان بنجاح ✅");
//     form.reset();
//     setImages([]);
//   } catch (error) {
//     toast.error("حدث خطأ أثناء الإرسال ❌");
//   } finally {
//     setFormSubmitting(false);
//   }
// };
const handleSubmit = async (e) => {
  e.preventDefault();

  const form = e.currentTarget;

  const nameEl = form.elements.namedItem("name");
  const priceEl = form.elements.namedItem("price");
  const discountEl = form.elements.namedItem("discount");
  const descEl = form.elements.namedItem("description");

  let newErrors = {};

  const name = nameEl?.value?.trim() || "";
  const price = priceEl?.value || "";
  const discount = discountEl?.value || 0;
  const description = descEl?.value?.trim() || "";

  // ========= Validation =========
  if (!name) newErrors.name = "الاسم مطلوب";

  if (!price || Number(price) <= 0) newErrors.price = "السعر مطلوب";

  if (!description) newErrors.description = "الوصف مطلوب";

  if (images.length === 0) newErrors.images = "مطلوب صورة واحدة على الأقل";

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  setErrors({});
  setFormSubmitting(true);

  try {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("price", price);
    formData.append("discount", discount);
    formData.append("description", description);
formData.append("category_id", selectedCategoryId);
    images.forEach((img) => formData.append("images[]", img.file));
//     for (let pair of formData.entries()) {
//   console.log(pair[0], pair[1]);
// }

    const token = localStorage.getItem("token");

    await axios.post(BaseUrl + BuyerServicesUrl.AddAdvertisement, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    toast.success("تم نشر الإعلان بنجاح ✅");
    form.reset();
    setImages([]);
  } catch (error) {
    toast.error("حدث خطأ أثناء الإرسال ❌");
  } finally {
    setFormSubmitting(false);
  }
};
  return (
    <div className="add-ad-page container mt-5 pt-4 mb-5 pb-5">
      <h2 className="page-title mt-5 mb-4 headeradvertisement">
        إضافة إعلان <span>/ الرئيسية</span>
      </h2>

      <Form className="ad-form" onSubmit={handleSubmit}>

        {/* Name */}
        <Form.Group className="mb-4">
          <Form.Label>اسم المنتج</Form.Label>
          <Form.Control
            type="text"
            name="name"
            placeholder="اسم المنتج"
            className={errors.name ? "is-invalid" : ""}
              onChange={() => {
    setErrors((prev) => ({ ...prev, name: "" }));
  }}
          />
          {errors.name && (
            <small className="text-danger">{errors.name}</small>
          )}
        </Form.Group>

        {/* Price + Discount */}
        <Row>
     <Col md={6}>
  <Form.Group className="mb-4">
    <Form.Label>السعر</Form.Label>

    <Form.Control
      type="number"
      name="price"
      placeholder="ادخل السعر"
      min="0"
      step="1"
      onKeyDown={(e) => {
        if (e.key === "-" || e.key === "e" || e.key === "E") e.preventDefault();
      }}
      className={errors.price ? "is-invalid" : ""}
        onChange={() => {
    setErrors((prev) => ({ ...prev, price: "" }));
  }}
    />

    {errors.price && (
      <small className="text-danger">{errors.price}</small>
    )}
  </Form.Group>
</Col>

          <Col md={6}>
                 <Form.Group className="mb-4">
  <Form.Label>نسبة الخصم</Form.Label>

  <div className="discount-wrapper position-relative">
    <div className="percent-box ">%</div>

    <input
      type="number"
      name="discount"
      placeholder="0"
      min="0"
      max="100"
      className="discount-input"
    />
  </div>
</Form.Group>
          </Col>
          

   

        </Row>

        {/* Description */}
        <Form.Group className="mb-4">
          <Form.Label>وصف المنتج</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            name="description"
            placeholder="اكتب وصف المنتج هنا..."
            className={errors.description ? "is-invalid" : ""}
              onChange={() => {
    setErrors((prev) => ({ ...prev, description: "" }));
  }}
          />
          {errors.description && (
            <small className="text-danger">{errors.description}</small>
          )}
        </Form.Group>

        {/* Image Upload */}
        <div className="images-section mb-4">
          <Form.Label>الصور (الحد الأقصى 10)</Form.Label>

          <div className="upload-box">
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={(e) => {
    handleImagesUpload(e);
    setErrors((prev) => ({ ...prev, images: "" }));
  }}
              className="upload-input"
            />
            <div className="upload-content">
              <p>إضافة صور</p>
            </div>
          </div>

          {errors.images && (
            <small className="text-danger d-block mt-2">
              {errors.images}
            </small>
          )}

          <div className="preview-images">
            {images.map((img, index) => (
              <div key={index} className="preview-item">
                <img src={img.url} alt={`uploaded-${index}`} />
                <button
                  type="button"
                  className="remove-btn"
                  onClick={() => deleteImage(index)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>

        <Button
          type="submit"
          className="submit-btn mb-5"
          disabled={formSubmitting}
        >
          {formSubmitting ? "جارٍ النشر..." : "نشر الإعلان"}
        </Button>
      </Form>





      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        rtl
        theme="colored"
      />
    </div>
  );
}
